import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CartActions, StateWithMultiCart } from '@spartacus/cart/base/core';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { map, Subscription, switchMap } from 'rxjs';
import { CartTrackingService } from 'src/app/customServices/cart-tracking.service';
import { KbCheckOutService } from 'src/app/services/feature/CheckOut/kb-check-out.service';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';
import { MultiCartFacade } from '@spartacus/cart/base/root';
@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss'],
  standalone: false
})
export class OrderSummaryComponent {
  isMobile: boolean;
  orderConfirmation: any;
  timeZoneMsg: string = '';
  sub = new Subscription();
  fleetPrideGroup: any;
  showCorePrice$ = this.custIDService.showCorePrice$;
  showNetPrice$ = this.custIDService.showNetPrice$;
  showListPrice$ = this.custIDService.showListPrice$;
  panelOpenState: boolean = false;
  constructor(
    private breakpointObserver: BreakpointObserver,
    private activatedRoute: ActivatedRoute,
    private kbCheckoutService: KbCheckOutService,
    private cdr: ChangeDetectorRef,
    private translationService: TranslationService,
    private globalMessageService: GlobalMessageService,
    public custIDService: CustomerIdService,
    private router: Router,
    protected store: Store<StateWithMultiCart>,
    private cartTrackingService: CartTrackingService,
    private multiCartService: MultiCartFacade,
  ) { }

  ngOnInit() {
    this.sub.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe((result) => {
          this.isMobile = result.matches;
        })
    );

    this.sub.add(
      this.activatedRoute.queryParamMap
        .pipe(
          map((params) => params.get('orderId')),
          switchMap((orderId) => this.kbCheckoutService.orderConfirmation(orderId))
        )
        .subscribe((x: any) => {
          this.orderConfirmation = x;
          this.cartTrackingService.trcakOrder(x?.site, x?.code, x?.totalPriceWithTax.formattedValue, x?.totalPriceWithTax.currencyIso, x?.status, this.orderConfirmation?.entries, x.currentB2BUnit.uid);
          this.checkCutOff();
          this.cdr.detectChanges();
        })
    );
    this.sub.add(
      this.custIDService.fleetPrideGroup$.subscribe(x => {
        this.fleetPrideGroup = x;
        this.cdr.detectChanges();
      })
    );
    this.sub.add(this.custIDService.setSpecificCustomerId().subscribe((data: any) => {
      if (data?.userWSDTO?.cartId) {
        this.store.dispatch(new CartActions.SetActiveCartId(data.userWSDTO.cartId));
        this.multiCartService.reloadCart(data.userWSDTO.cartId, {
          active: true,
        });
      }
    }))
  }
  checkCutOff() {
    if (this.orderConfirmation?.emergencyNote?.note && this.orderConfirmation?.emergencyNote?.note.errorValue1) {
      this.sub.add(this.translationService
        .translate(this.orderConfirmation?.emergencyNote.note.message)
        .subscribe((val) => {
          this.timeZoneMsg = val.replace("{0}", this.orderConfirmation.emergencyNote.note.errorValue1).replace("{1}", this.orderConfirmation.emergencyNote.note.errorValue2).replace("{2}", this.orderConfirmation.emergencyNote.note.errorValue3)
        }));
    }
  }

  continueShopping() {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR, 1);
    this.router.navigateByUrl('/');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
